<template lang="pug">
  .analise
    modal-visualizar-gleba(
      v-if="modal"
      :idGleba="idGleba"
      @closeModal="closeModal()"
      :titulo="titulo"
    )
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clearFiltro",
        @changePesquisa="changePesquisa",
        :configuracaoFiltro="configuracaoFiltro"
        :filtro="filtro",
        :isConsultaProcessosAntigos="false"
      )
    app-listagem(
      :hasActionButton="true"
      :sizeActionButton="sizeActionButton"
      :nameActionButton="nameActionButton"
      :hasHeader="true"
      :hasRefreshButton="false"
      :headerLabel="headerLabel"
      :dataForTable="glebas"
      :totalElements="totalElements"
      :pagina="filtro.pagina + 1"
      @click="cadastrar"
      @changePage="changePage"
      @sort="sort"
    )
      template(slot="columns")
        el-table-column(
          :formatter="(row) => setData(row.dataCadastro)"
          label='Data de Cadastro',
          min-width="120"
          prop= "dataCadastro"
          sortable
        )
        el-table-column(
          label='Município da gleba',
          min-width='120',
          :formatter="(row) => getMunicipiosNome(row.municipios)"
          prop='municipios',
          sortable
        )
        el-table-column(
          label='Nome da gleba',
          prop='nome'
          min-width='120',
          sortable
        )
        el-table-column(
          label='Área total(ha)',
          prop='areaTotal'
          :formatter="(row) => formatarArea(row.areaTotal)"
          min-width='120',
          sortable
        )
        el-table-column(
          label='Área remanescentes(ha)',
          prop='areaRemanescente',
          :formatter="(row) => formatarArea(row.areaRemanescente)"
          sortable
          min-width='120'
        )
        el-table-column(
          label='Matrícula',
          prop='matricula',
          sortable
          min-width='120'
        )
        el-table-column(
          label='Data matrícula',
          :formatter="(row) => setData(row.dataMatricula)"
          min-width='120',
          prop='dataMatricula',
          sortable,
        )

        el-table-column(
          label="Ações",
          width="110",
          align="center"
        )
          template(slot-scope='scope')
            el-dropdown(trigger="click", size="small")
              el-button(type='primary', size="mini")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown')
                div
                  el-dropdown-item
                    .flex(@click="visualizar(scope.row)")
                      i.fa.fa-eye.icon-teste
                      | &nbsp Visualizar
                div
                  el-dropdown-item
                    .flex(@click="editar(scope.row)")
                      i.fal.fa-pencil-alt.icon-teste
                      | &nbsp Editar
                div
                  el-dropdown-item
                    .flex(@click="remove(scope.row)")
                      i.fa.fa-times.icon-teste
                      | &nbsp Excluir
    div.container-exportar
      el-button(
        @click="exportar"
      )
        span
          i.fal.fa-file-csv
          | &nbsp Exportar CSV
</template>
<script>

import Filtro from '../components/Filter.vue'
import AppListagem from '@/components/shared/AppListagem'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FILTRO_EMPTY from '../models/filtroGleba'
import ModalVisualizarGleba from './ModalVisualizarGleba.vue'
import { mapActions } from 'vuex'
import moment from 'moment'
import AppModalVisualizarCompleto from '../../analise/components/modal/AppModalVisualizarCompleto.vue'

export default {
  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalVisualizarGleba
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      showModalVisualizarProcesso: false,
      glebas: [],
      items: [],
      processo: undefined,
      showModal: false,
      totalElements: 0,
      configuracaoFiltro: {},
      headerLabel: 'Listagem de Glebas',
      sizeActionButton: 'medium',
      nameActionButton: 'Cadastrar Gleba',
      modal: false,
      idGleba: null,
      titulo: '',
      filtro: {...FILTRO_EMPTY()}
    }
  },

  computed: {
  },

  created () {
    this.pesquisar(this.filtro)
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      getGlebas: 'gleba/listar',
      remover: 'gleba/remover',
      getCsv: 'gleba/getCsv'
    }),
    cadastrar () {
      this.$router.push({
        name: 'bancoDados/gleba/cadastro',
        params: {}
      })
    },
    editar (gleba) {
      this.confirmBox(this.$messages.EDITAR_GLEBA,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'bancoDados/gleba/editar',
            params: {
              id: gleba.id
            }
          })
        },
        () => {})
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.pesquisar(this.filtro)
    },
    async pesquisar (filtro) {
      this.filtro.pagina = filtro.pagina
      let response = await this.getGlebas(filtro)
      this.glebas = response.content
      this.totalElements = response.totalElements
    },
    async remove (gleba) {
      this.confirmBox(this.$messages.REMOVER_GLEBA,
        this.$messages.TITULO_WARNING,
        () => {
          this.remover(gleba.id).then(item => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Gleba removida com sucesso.')
            this.pesquisar({...FILTRO_EMPTY()})
          })
        },
        () => {})
    },
    visualizar (gleba) {
      this.titulo = `Visualização da gleba - ${this.getMunicipiosNome(gleba.municipios, ' | ')}`
      this.idGleba = gleba.id
      this.modal = true
    },
    async clearFiltro () {
      this.filtro = {...FILTRO_EMPTY()}
      await this.pesquisar(this.filtro)
    },
    changePesquisa () {
      this.filtro = {
        ...FILTRO_EMPTY(),
        simplificado: !this.filtro.simplificado
      }
    },
    setData (data) {
      return data ? moment(data).format('DD/MM/YYYY') : '-'
    },
    getMunicipiosNome (municipios, sepadarador = ', ') {
      return municipios.map(item => item.nome).join(sepadarador)
    },
    formatarArea (area) {
      return area ? area.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : '-'
    },
    closeModal () {
      this.modal = false
    },
    sort ({ column, prop, order }) {
      if (order === 'ascending') {
        this.filtro.ordemDirecao = 'ASC'
      } else {
        this.filtro.ordemDirecao = 'DESC'
      }
      this.filtro.ordem = prop
      this.pesquisar(this.filtro)
    },
    exportar () {
      let filtroFormatado = {
        ...this.filtro,
        dataInicialCadastro: this.filtro.dataCadastro ? this.filtro.dataCadastro[0] : null,
        dataFinalCadastro: this.filtro.dataCadastro ? this.filtro.dataCadastro[1] : null,
        dataInicialMatricula: this.filtro.dataMatricula ? this.filtro.dataMatricula[0] : null,
        dataFinalMatricula: this.filtro.dataMatricula ? this.filtro.dataMatricula[1] : null
      }
      this.getCsv(filtroFormatado)
    }
  }
}

</script>
<style>
.label {
  font-weight: bold;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}
.container-btn {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
.flex {
  display: flex;
  align-items: center;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-cadastar-foto {
  margin: 20px;
  color: #000;
}
.icon-teste {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px !important;
  margin: 0px !important;
}
.container-exportar {
  display: flex;
  justify-content: end;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/gleba/GlebaImovel.vue